"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var context_1 = require("../shared/context");
exports.useSchemaProps = function () { return react_1.useContext(context_1.SchemaFieldPropsContext); };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react-schema-renderer/lib/hooks/useSchemaProps.js
// module id = 4665
// module chunks = 0